export enum DiscussableDTO {
  NetworkShare = 'NetworkShare',
  Company = 'Company',
  Targeting = 'Targeting',
  SSPContract = 'SSPContract',
  Screen = 'Screen',
  PlaybackScheduleSlot = 'PlaybackScheduleSlot',
  ScreenHardware = 'ScreenHardware',
  Product = 'Product',
  PlayerHardware = 'PlayerHardware',
  CullCategory = 'CullCategory',
  ContentShareQuota = 'ContentShareQuota',
  Pool = 'Pool',
  Budget = 'Budget',
  MediumGroup = 'MediumGroup',
  Client = 'Client',
  CampaignType = 'CampaignType',
  MediumGroupCategory = 'MediumGroupCategory',
  PlayerSoftware = 'PlayerSoftware',
  Device = 'Device',
  Channel = 'Channel',
  Booking = 'Booking',
  Marker = 'Marker',
  Deal = 'Deal',
  Commercial = 'Commercial',
  Role = 'Role',
  Requirement = 'Requirement',
  SSP = 'SSP',
  Area = 'Area',
  Cull = 'Cull',
  Campaign = 'Campaign',
  Medium = 'Medium',
  ContentShare = 'ContentShare',
  PlaybackSchedule = 'PlaybackSchedule',
  Tag = 'Tag',
  Planning = 'Planning',
  AreaCategory = 'AreaCategory',
  LocationType = 'LocationType',
  NetworkPriceModel = 'NetworkPriceModel',
  Location = 'Location',
}
